import Vue from "vue";
import Vuetify, { VSnackbar, VBtn, VIcon } from "vuetify/lib";
import ru from "vuetify/es5/locale/ru";
import VuetifyToast from "vuetify-toast-snackbar";

const vuetifyToastConfig = {
    x: "right",
    y: "top",
    color: "info",
    classes: "color-white", // default
    timeout: 3000, // default
    dismissable: true, // default
    multiLine: true, // default
    vertical: false, // default
    showClose: true, // default
    closeIcon: "mdi-close", // default
    slot: [],
    property: "$toast",
};

Vue.use(Vuetify, {
    components: {
        VSnackbar,
        VBtn,
        VIcon,
    },
});

Vue.use(VuetifyToast, vuetifyToastConfig);

export default new Vuetify({
    lang: {
        locales: { ru },
        current: "ru",
    },
    icons: {
        iconfont: "mdi",
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: "#27AE60",
                secondary: "#FDDD2E",
                anchor: "#2196F3",
                spinner: "#BDBDBD",
                lightgrey: "#E0E0E0",
            },
        },
    },
});
